import axios from 'axios';
import * as R from 'ramda';
import {observable, action, flow, runInAction} from 'mobx';

import {mapPostStateToCreatorContentNotifier} from 'js/api_reducers/creator_notifications';
import proxyRequest from 'js/proxy_api_client';

export default class ContentApprovalStore {
    @observable campaign_id = window.sn.campaign.id;
    @observable.struct content = {
                content_metadata_id: '',
                post_state: ''
            };
    @observable transmitting = false;

    updateContentUrl = null;

    constructor(content) {
        runInAction(() => {
            this.campaign_id = window.sn.campaign.id;
            this.content = content != null ? content : {
                content_metadata_id: '',
                post_state: ''
            };
        });
        this.updateContentUrl = window.sn.urls.update_content_metadata_distribution_approval_status.replace(
            '__CONTENT_METADATA_ID__',
            this.content.content_metadata_id
        );
        this.handleSaveNote = this.handleSaveNote.bind(this);
        this.handleUpdateContentStatus = this.handleUpdateContentStatus.bind(this);
        this.handleResetBrandContentStatus = this.handleResetBrandContentStatus.bind(this);
        this.updateContent = this.updateContent.bind(this);
        this.handleSendRequestFix = this.handleSendRequestFix.bind(this);
        this.handleNotifyCreator = this.handleNotifyCreator.bind(this);
        this.fetch = this.fetch.bind(this);
    }

    handleUpdateContentStatus = flow(function*(desiredStatus) {
        return yield this.updateContent({admin_distribution_approval_status: desiredStatus});
    });

    handleResetBrandContentStatus = flow(function*() {
        return yield this.updateContent({
            brand_distribution_approval_status: 'pending',
            post_state_change_reason: 'ADMIN_RESET_BRAND_APPROVAL'
        });
    });

    foo = function*(patch) {
        yield 1;
    }

    updateContent = flow(/** @this ContentApprovalStore */function*(patch) {
        if (R.isEmpty(patch)) {
            return;
        }

        this.transmitting = true;

        try {
            yield axios.post(this.updateContentUrl, patch);
            yield this.fetch();
        } catch (error) {
            console.error(error);
        }

        this.transmitting = false;
    });

    handleSendRequestFix = flow(/** @this ContentApprovalStore */function*(feedback) {
        this.transmitting = true;
        try {
            yield axios.post(
                window.sn.urls.apply_content_metadata_update_action.replace(
                    '__CONTENT_METADATA_ID__',
                    this.content.content_metadata_id
                ),
                {
                    action: 'fix',
                    suppress_creator_notification: false,
                    rejection_reasons: R.split('\n', feedback)
                }
            );

            yield this.fetch();
        } catch (error) {
            console.error(error);
        }

        this.transmitting = false;
    });

    handleSaveNote = flow(/** @this ContentApprovalStore */function*(feedback) {
        this.transmitting = true;

        try {
            yield axios.post(window.sn.urls.createContentMetadataComment, {
                content_metadata_id: this.content.content_metadata_id,
                messages: R.split('\n', feedback),
                comment_source: 'general_note'
            });

            yield this.fetch();
        } catch (error) {
            console.error(error);
        }

        this.transmitting = false;
    });

    handleNotifyCreator = flow(/** @this ContentApprovalStore */function*() {
        this.transmitting = true;

        try {
            yield mapPostStateToCreatorContentNotifier(this.content.post_state)(
                this.content.content_metadata_id
            )();

            yield this.fetch();
        } catch (error) {
            console.error(error);
        }

        this.transmitting = false;
    });

    fetch = flow(/** @this ContentApprovalStore */function*() {
        this.transmitting = true;

        try {
            const {
                data: {results}
            } = yield proxyRequest(
                'post',
                // eslint-disable-next-line max-len
                `api/v2/execution/campaign/${this.campaign_id}/get_posts_pending_distribution_review`,
                {
                    data: {
                        filters: {
                            pagination: {
                                p: 0,
                                pp: 1
                            },
                            search: {
                                searchable_fields: ['content_metadata.id'],
                                search_value: this.content.content_metadata_id?.toString() ?? ''
                            }
                        },
                        to_skip: []
                    }
                }
            );

            this.transmitting = false;

            const [content] = results;

            if (content) {
                this.content = content;
            }
        } catch (error) {
            console.error(error);
        }
    });

    @action
    handleAddPotentialDistribution = () => {
        this.content.potential_distribution_status = 'distribution_matched';
    };

    @action
    toggleTransmissionState = () => {
        this.transmitting = !this.transmitting;
    };
}



// WEBPACK FOOTER //
// ./approval_queues/state/content_approval_store.js